/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_TeamInputs */

const es_admin_company_overview_plans_team = /** @type {(inputs: Admin_Company_Overview_Plans_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const en_admin_company_overview_plans_team = /** @type {(inputs: Admin_Company_Overview_Plans_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Admin_Company_Overview_Plans_TeamInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_team = /** @type {((inputs?: Admin_Company_Overview_Plans_TeamInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_TeamInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_team(inputs)
	return en_admin_company_overview_plans_team(inputs)
});
export { admin_company_overview_plans_team as "admin.company_overview.plans.team" }